import styled from "@emotion/styled";
import {
    colors,
    colorVariables,
    fontSizes,
    gutterSizes,
    fontWeights,
    boxSizes,
    mediaQuery,
    breakpoints,
} from "@gumtree/ui-library/src/base/theme";
import { ButtonsContainer } from './message-buttons.style'

interface MessageContainerProps {
    hasMessageError: boolean;
    hasPhoneError: boolean;
}

export const MessageContainer = styled.div<MessageContainerProps>`
    display: grid;
    grid-row-gap: ${gutterSizes.base};
    grid-template-areas:
        "provide-message"
        "provide-phone"
        ${({ hasPhoneError }) => (hasPhoneError ? '"phone-errors"' : undefined)}
        ${({ hasMessageError }) => (hasMessageError ? '"message-errors"' : undefined)}
        "send-message-tip"
        "message-buttons";

    fieldset[name="provide-message"],
    fieldset[name="provide-phone"] {
        border: 0;
        margin: 0;
        padding: 0;
        .input-clear {
            display: none;
        }
    }

    label {
        font-size: ${fontSizes.small};
        font-weight: ${fontWeights.bolder};
    }

    fieldset[name="provide-message"] {
        grid-area: provide-message;
    }

    fieldset[name="provide-phone"] {
        grid-area: provide-phone;
    }

    ${ButtonsContainer} {
        ${mediaQuery.until(breakpoints.medium)} {
            margin-top: ${gutterSizes.base};
        }
    }
`;

export const PhoneInput = styled.input<{ error: boolean }>`
    width: 100%;
    box-sizing: border-box;
    min-width: 200px;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 46px;
    padding: ${gutterSizes.medium};
    border: 1px solid #d8d6d9;
    border-radius: 2px;
    color: ${colorVariables.fontPrimary};
    font-size: ${fontSizes.medium};
    font-weight: ${fontWeights.normal};
    border-radius: ${boxSizes.borderRadius4};
    &:focus, &:focus-visible {
        border-color: ${colors.bark80};
        outline: none;
    }
    ${({ error }) => (error ? `
        border-color: ${colors.red};
        &:focus, &:focus-visible {
            border-color: ${colors.red};
            outline: none;
        }
    ` : undefined)}
`;

export const ProSellerSubtitle = styled.p`
    font-size: ${fontSizes.small};
    color: ${colorVariables.fontTeritary};
    margin: 0;
`;

export const SendMessageTip = styled.div`
    grid-area: send-message-tip;

    font-size: ${fontSizes.small};
    color: ${colorVariables.fontTeritary};

    .hint-tooltip {
        display: inline-block;
        color: ${colorVariables.fontPrimary};
        font-size: ${fontSizes.small14};
        font-weight: ${fontWeights.normal};

        .icon {
            transform: translateY(-2px);
        }

        .hint-tooltip-content {
            width: 285px !important;
        }

        .hint-tooltip-content.hint-tooltip-direction--top {            
            top: auto !important;
            transform: translateX(calc(-50%));
            &:before {
                left: calc(90%);
            }
        }

        a {
            color: ${colorVariables.fontPrimary};
            font-size: ${fontSizes.small14};
            font-weight: ${fontWeights.normal};
            text-decoration: underline;
        }
    }
`;

export const Errors = styled.ul`
    li {
        color: ${colors.red};
    }
`;

export const MessageErrors = styled(Errors)`
    grid-area: message-errors;
`;

export const PhoneErrors = styled(Errors)`
    grid-area: phone-errors;
`;
